import React, { useEffect, useState } from "react";
import { BallTriangle } from "react-loader-spinner";
import CourseCatregoryCard from "./CourseCatregoryCard";

const CourseCategory = () => {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState([]);
  useEffect(() => {
    setLoading(true);
    fetch(
      "https://b610-lerning-platform-server-side-asifsikder23.vercel.app/course"
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setLoading(false);
        setDetails(data);
      });
  }, []);
  return (
    <div className="container mx-auto">
      <h1 className="text-5xl text-center font-bold py-5">
        Discover Our Popular Courses
      </h1>
      <p className="text-center text-lg">
        It is a long established fact that a reader will be distracted by the
        readable content of a page when looking at its layout.
      </p>
      {loading ? (
        <div className="flex justify-center items-center">
          <BallTriangle
          height={100}
          width={100}
          radius={5}
          color="#4fa94d"
          ariaLabel="ball-triangle-loading"
          wrapperClass={{}}
          wrapperStyle=""
          visible={true}
        />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 my-10">
          {details.map((course) => (
            <CourseCatregoryCard
              key={course._id}
              course={course}
            ></CourseCatregoryCard>
          ))}
        </div>
      )}
    </div>
  );
};

export default CourseCategory;
